export const USER_SCRIPT = "USER_SCRIPT";
export const PLANAR_SCRIPT = "PLANAR_SCRIPT";
export const SHADER_SCRIPT = "SHADER_SCRIPT";
